export const characterLabel = ({ label, characterName }) =>
  label ?? characterName ?? null;

export const toCardSource = ({ headshot, character }) => ({
  headshot,
  primaryCharacter: character[0] ?? null,
});

export const cardImage = ({ headshot, primaryCharacter }) =>
  primaryCharacter
    ? {
        main: primaryCharacter.url,
        overlay: headshot?.squareUrl ?? null,
        mainLabel: characterLabel(primaryCharacter),
      }
    : { main: headshot?.url ?? null, overlay: null, mainLabel: null };

export const characterStack = (max, images) => ({
  visible: images.slice(0, max),
  overflow: Math.max(0, images.length - max),
});

const legacyHeadshot = ({ avatarUrl, avatar_url: avatarUrlSnake }) => {
  const url = avatarUrl || avatarUrlSnake || null;

  return url ? { url, squareUrl: url } : null;
};

export const cardSourceFromRow = (row) => ({
  headshot:
    row.cardHeadshot === undefined ? legacyHeadshot(row) : row.cardHeadshot,
  primaryCharacter: row.cardPrimaryCharacter ?? null,
});

const famousCaption = ({ famousFor, famousCharacter }) =>
  [famousCharacter, famousFor].filter(Boolean).join(" / ");

export const shopCardCaption = ({ mainLabel, ...shop }) =>
  mainLabel ?? famousCaption(shop);

const wholePixel = (value) => Math.max(0, Math.round(value));

export const toPixelCrop = ({ x, y, width, height }) => ({
  x: wholePixel(x),
  y: wholePixel(y),
  width: wholePixel(width),
  height: wholePixel(height),
});

export const withCharacterOrder = (imageIds) => (shopImages) => {
  const byId = new Map(
    shopImages.character.map((image) => [image.imageId, image]),
  );

  return {
    ...shopImages,
    character: imageIds.map((imageId, position) => ({
      ...byId.get(imageId),
      position,
    })),
  };
};

export const shopCardText = ({ source, name, famousFor, famousCharacter }) => {
  const { mainLabel } = cardImage(source);

  return mainLabel
    ? {
        title: mainLabel,
        subtitle: [name, source.primaryCharacter.franchiseName]
          .filter(Boolean)
          .join(" · "),
        isCharacterTitle: true,
      }
    : {
        title: name,
        subtitle: shopCardCaption({ mainLabel, famousFor, famousCharacter }),
        isCharacterTitle: false,
      };
};
